import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const serviceImporterSelectors = importerSelectors(
  'service.importer',
)

export default serviceImporterSelectors
